export default __webpack_public_path__ + "static/media/1819.1e174b01.png";